import { Backdrop, CircularProgress } from '@mui/material'
import React, { createContext, useContext } from 'react'

const LoadingPopupContext = createContext({
  open: false,
  handleStartLoading: () => { },
  handleStopLoading: () => { },
});

const LoadingContext = ({ children }) => {
  const [open, setOpen] = React.useState(false);

  const handleStartLoading = () => {
    setOpen(true);
  };
  const handleStopLoading = () => {
    setOpen(false);
  };
  return (
    <LoadingPopupContext.Provider value={{ open, handleStartLoading, handleStopLoading }}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {children}
    </LoadingPopupContext.Provider>
  )
}

export const useLoadingContext = () => useContext(LoadingPopupContext);

export default LoadingContext
